var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasArticles)?_c('v-container',{staticClass:"pa-0"},[_c('Posts')],1):_c('NoData',{attrs:{"hasItems":false,"isNotFoundPage":false,"typeData":'article'}})
}
var staticRenderFns = []

export { render, staticRenderFns }